import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "@/context/AuthContext";

// Feuert bei jedem Route-Wechsel auf öffentlichen Seiten ein Tracking-Beacon
// an /api/track. Admin-Routen sind ausgeschlossen. Fire-and-forget, kein
// UI-Effekt, kein Blockieren des Renderings.
export default function VisitorTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname || pathname.startsWith("/admin")) return;
    const payload = { path: pathname, referrer: document.referrer || "" };
    try {
      const body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        const ok = navigator.sendBeacon(`${API}/track`, blob);
        if (ok) return;
      }
      axios.post(`${API}/track`, payload).catch(() => {});
    } catch {
      /* Tracking ist optional – Fehler werden bewusst geschluckt */
    }
  }, [pathname]);
  return null;
}
